import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";

const UserItem = ({ user: { html_url, login, avatar_url } }) => {
  return (
    <div className="cart text-center">
      <img
        className="round-img"
        src={avatar_url}
        alt="github"
        style={{ width: "60px" }}
      />
      <h3>{login}</h3>
      <div>
        <Link to={`/user/${login}`} className="btn btn-dark btn-sm my-1">
          More
        </Link>
      </div>
    </div>
  );
};

UserItem.propTypes = {
  //ptor is the shortcut
  user: PropTypes.object.isRequired,
};

export default UserItem;
